module.exports = __webpack_public_path__ + "img/sec-263-HMC.a646a037.svg";